export default __webpack_public_path__ + "static/media/fast.5deb7a60.png";